import { Ref } from '@nuxtjs/composition-api';
import { EngravingOptionInput } from '~/modules/GraphQL/types';

export interface useProductEngravingInterface {
  engraving: Ref<ProductEngraving>;
  isEngravingLoading: Readonly<Ref<boolean>>;
  shouldIncludeEngraving: Readonly<Ref<boolean>>;
  isEngravingModalOpened: Readonly<Ref<boolean>>;
  engravingOptions: Readonly<Ref<EngravingOptionInput>>;
  setActiveEngraving(value?: EngravingOptionInput);
  setEngravingModalOpenState(opened?: boolean);
}

export interface ProductEngraving {
  sku: string;
  engraving_price: number;
  engraving_enabled: number;
  engraving_options: {
    place: Array<{
      label: string;
      type: string;
    }>;
    anchors: Array<ProductEngravingAnchor>;
  };
}

export type ProductEngravingAnchor = {
  place: string;
  font: string[];
  font_size: string | null;
  color: string | null;
  max_length: number | null;
  image: {
    url: string | null;
  };
  position: {
    rotation: number | null;
    x: number | null;
    y: number | null;
  };
};

export declare type GetProductEngraving = {
  products: {
    items: ProductEngraving[];
  };
};

export enum EngravingPlaceEnum {
  'Gravur auf Clip' = 'CLIP',
  'Gravur auf dem Schaft' = 'SHAFT',
}

enum EngravingAnchorEnum {
  LEFT,
  RIGHT,
}
